/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import imgPageNotFound from './img_PageNotFound.png';

export default class NotFound extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    datadogRum.addError('Page not found');
    return (
      <div style={{ fontSize: '20px', height: '80vh' }} className="d-flex my-auto align-items-center justify-content-center">
        <div>
          <img src={imgPageNotFound} className="mt-1 mx-auto d-block" alt="" />
          <p className="mt-1 mx-auto d-flex justify-content-center">Sorry! This page is not found or does not exist.</p>
          <a className="mt-1 mx-auto d-flex justify-content-center" href="/">Return to Taxi homepage</a>
        </div>
      </div>
    );
  }
}
